
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Mission', path: '/mission' },
    { name: 'App', path: '/app' },
    { name: 'Education', path: '/education' },
    { name: 'Supplementation', path: '/supplementation' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Impact', path: '/impact' },
    { name: 'Donate', path: '/donate' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`}>
      <nav className="mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/e02ccdad9401b4ae7d91a47c24564639.png" 
              alt="Diatomic Life Foundation" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-xl font-bold text-[#111111] font-display">
              Diatomic Life Foundation
            </span>
          </Link>

          {/* Desktop Navigation with Teal Band */}
          <nav className="hidden md:flex items-center">
            <div className="bg-[#12B6B6] px-8 py-3 rounded-full shadow-lg">
              <div className="flex items-center space-x-8">
                <Link to="/" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Home
                </Link>
                <Link to="/mission" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Mission
                </Link>
                <Link to="/supplementation" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Supplementation
                </Link>
                <Link to="/app" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  OxyAI
                </Link>
                <Link to="/education" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Education
                </Link>
                <Link to="/testimonials" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Testimonials
                </Link>
                <Link to="/impact" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Impact
                </Link>
                <Link to="/donate" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                  Donate
                </Link>
              </div>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden w-6 h-6 flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl text-[#111111]`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4 pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-sm font-medium transition-colors duration-200 hover:text-[#12B6B6] ${
                    location.pathname === item.path ? 'text-[#12B6B6]' : 'text-[#111111]'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-2">
                <Button variant="primary" size="sm" className="w-full">
                  Donate
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
